import React, { useState } from "react";
import { api } from "../lib/api";
import { useT } from "../lib/i18n";
import { FloppyDisk, CaretDown, CaretUp, UserCircle } from "@phosphor-icons/react";

export default function PRRCWidget({ project, onChange }) {
  const t = useT();
  const [open, setOpen] = useState(false);
  const [prrc, setPrrc] = useState(project.prrc || { name: "", qualification: "", contact: "" });
  const [saving, setSaving] = useState(false);

  const set = (k, v) => setPrrc({ ...prrc, [k]: v });
  const ok = !!(prrc.name && prrc.qualification);

  async function save() {
    setSaving(true);
    try {
      await api.put(`/projects/${project.id}/prrc`, prrc);
      onChange?.();
      setOpen(false);
    } finally { setSaving(false); }
  }

  return (
    <div className="grid-card p-4" data-testid="prrc-widget">
      <div className="flex items-center justify-between cursor-pointer" onClick={() => setOpen(!open)}>
        <div className="flex items-center gap-2">
          <UserCircle size={18} weight="duotone" className="text-[var(--accent-text)]" />
          <div>
            <div className="text-xs font-mono uppercase tracking-wider text-[var(--text-2)]">{t("prrc.title")}</div>
            <div className="text-sm">{ok ? <span className="font-semibold">{prrc.name}</span> : <span className="text-[var(--text-2)]">— {t("prrc.sub")}</span>}</div>
          </div>
        </div>
        {open ? <CaretUp size={16} /> : <CaretDown size={16} />}
      </div>
      {open && (
        <div className="mt-4 pt-4 border-t border-[var(--border)] grid grid-cols-1 md:grid-cols-3 gap-3">
          <Field label={t("prrc.name")} v={prrc.name} on={(v) => set("name", v)} testid="prrc-name" />
          <Field label={t("prrc.qualification")} v={prrc.qualification} on={(v) => set("qualification", v)} testid="prrc-qual" />
          <Field label={t("prrc.contact")} v={prrc.contact} on={(v) => set("contact", v)} testid="prrc-contact" />
          <div className="md:col-span-3 flex justify-end">
            <button onClick={save} disabled={saving} data-testid="prrc-save-btn" className="btn-primary inline-flex items-center gap-2 px-3 py-1.5 text-xs">
              <FloppyDisk size={12} weight="bold" /> {saving ? "…" : t("prrc.save")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

function Field({ label, v, on, testid }) {
  return (
    <div>
      <label className="text-xs font-semibold uppercase text-[var(--text-2)]">{label}</label>
      <input value={v || ""} onChange={(e) => on(e.target.value)} data-testid={testid}
        className="mt-1 w-full border border-[var(--border)] bg-[var(--surface-elevated)] px-2 py-1.5 rounded-sm text-sm text-[var(--text)] focus:border-[var(--accent)] focus:outline-none" />
    </div>
  );
}
